import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = ({ footerData }) => {
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const toggleSubMenu = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index); // Toggle sub-menu visibility
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left Section: Logo, Optional Contact Information, and Social Icons */}
        <div className="footer-left">
          <div className="footer-logo">
            <Link to={footerData.logo.link}>
              <img src={footerData.logo.src} alt={footerData.logo.alt} />
            </Link>
          </div>

          {/* Conditionally Render Contact Info */}
          {footerData.contact && (footerData.contact.email || footerData.contact.phone) && (
            <div className="footer-contact">
              {footerData.contact.email && (
                <p><i className="fa fa-envelope"></i> <a href={`mailto:${footerData.contact.email}`}>{footerData.contact.email}</a></p>
              )}
              {footerData.contact.phone && (
                <p><i className="fa fa-phone"></i> <a href={`tel:${footerData.contact.phone}`}>{footerData.contact.phone}</a></p>
              )}
            </div>
          )}

          {/* Social Media Links */}
          <div className="footer-social">
            {footerData.socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.link}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit us on ${social.platform}`}
                className="footer-social-icon"
                style={{ backgroundColor: social.color }}
              >
                <i className={`fa fa-${social.platform.toLowerCase()}`} aria-hidden="true"></i>
              </a>
            ))}
          </div>
        </div>

        {/* Right Section: Menu and Sub-Menus */}
        <div className="footer-menu">
          {footerData.menu.map((item, index) => (
            <div
              key={index}
              className={`footer-menu-item ${activeSubMenu === index ? "open" : ""}`}
            >
              <span
                className="footer-menu-title"
                onClick={() => toggleSubMenu(index)}
              >
                {item.title}
              </span>
              <ul className={`footer-sub-menu ${activeSubMenu === index ? "open" : ""}`}>
                {item.subMenu.map((subItem, subIndex) => (
                  <li key={subIndex}>
                    <Link to={subItem.link}>{subItem.title}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-copyright">
        <p>{footerData.copyright.text}</p>
      </div>
    </footer>
  );
};

export default Footer;
